/**
 * @generated SignedSource<<ba4c6fbe30729dc5765a46a7ee0ca8c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_user">;
  readonly " $fragmentType": "MessageBannerContent_user";
};
export type MessageBannerContent_user$key = {
  readonly " $data"?: MessageBannerContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBannerContent_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "messageHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a2f7ca37cc192250d27cc89fdd2f906d";

export default node;
